module.exports = __webpack_public_path__ + "static/media/kushner-attias.1f6a6116.jpg";